// Outline icons from the prototype (24px grid), for the meeting panel and its entry points.
const PATHS = {
  calCheck: "M11.5 21H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v6 M16 3v4 M8 3v4 M4 11h16 M15 19l2 2 4-4",
  check: "M5 12l5 5L20 7",
  help: "M3 12a9 9 0 1 0 18 0 9 9 0 1 0-18 0 M12 17v.01 M12 13.5a1.5 1.5 0 0 1 1-1.5 2.6 2.6 0 1 0-3-4",
  x: "M18 6L6 18 M6 6l12 12",
  chevRight: "M9 6l6 6-6 6",
  lock: "M6 11a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1z M8.5 10V7.5a3.5 3.5 0 0 1 7 0V10",
  // LINE_ART.success
  success: "M19.2 12a7.2 7.2 0 1 1-14.4 0 7.2 7.2 0 0 1 14.4 0 M8.8 12l2.4 2.4 4.4-5.2",
} as const;

export type MeetingIconName = keyof typeof PATHS;

function MeetingIcon({ name, size = 18, className = "" }: { name: MeetingIconName; size?: number; className?: string }) {
  return (
    <svg
      className={`plg-mi ${className}`.trim()}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d={PATHS[name]} />
    </svg>
  );
}

export default MeetingIcon;
